import { Entity, EntityEdge } from './types';

export const sortEntityEdges: <T extends Entity>(edges: EntityEdge<T>[]) => EntityEdge<T>[] = (edges) =>
  [...edges].sort((a, b) => {
    const sortKeyA = a.sortKey || '';
    const sortKeyB = b.sortKey || '';

    if (sortKeyA > sortKeyB) {
      return -1;
    }

    if (sortKeyA < sortKeyB) {
      return 1;
    }

    return 0;
  });
